// src/pages/onboarding/WelcomeStep.jsx
import React from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import BoltRoundedIcon from "@mui/icons-material/BoltRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

const features = [
  "AI-powered lead prioritization",
  "Automated follow-up reminders",
  "Birthday and anniversary alerts",
  "Commission tracking and forecasting",
  "Centralized client management",
];

export default function WelcomeStep({ onNext }) {
  return (
    <Box sx={{ textAlign: "center" }}>
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: "50%",
          bgcolor: "primary.main",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mx: "auto",
          mb: 3,
        }}
      >
        <BoltRoundedIcon sx={{ fontSize: 40, color: "white" }} />
      </Box>

      <Typography variant="h4" fontWeight={800} gutterBottom>
        Welcome to AgentBlayna
      </Typography>

      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 4, maxWidth: 500, mx: "auto" }}
      >
        Your AI-powered real estate assistant is ready to help you close more
        deals and never miss a follow-up. Let's get you set up in just a few
        steps.
      </Typography>

      <Stack spacing={1.5} sx={{ mb: 4, maxWidth: 400, mx: "auto" }}>
        {features.map((feature) => (
          <Stack
            key={feature}
            direction="row"
            spacing={1.5}
            alignItems="center"
            sx={{ textAlign: "left" }}
          >
            <CheckCircleRoundedIcon sx={{ color: "success.main" }} />
            <Typography variant="body1">{feature}</Typography>
          </Stack>
        ))}
      </Stack>

      <Button
        variant="contained"
        size="large"
        onClick={onNext}
        sx={{
          px: 6,
          py: 1.5,
          borderRadius: 2,
          fontWeight: 700,
          fontSize: 16,
        }}
      >
        Get Started
      </Button>
    </Box>
  );
}
